import { createI18n } from 'vue-i18n'
import type { I18n } from 'vue-i18n'
import zhCN from './zh-CN.json'
import enUS from './en-US.json'

export type LocaleType = 'zh-CN' | 'en-US'

export const availableLocales: { value: LocaleType; label: string }[] = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en-US', label: 'English' }
]

function getDefaultLocale(): LocaleType {
  const envLang = import.meta.env.VITE_LANG as LocaleType | undefined
  if (envLang && availableLocales.some((l) => l.value === envLang)) {
    return envLang
  }
  return 'en-US'
}

const i18n: I18n = createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: import.meta.env.VITE_LANG,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})


export default i18n
